import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs, Box, Typography, List, ListItem } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import routes from '../../routes';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import FoodDonorPendingMobileCard from './FoodDonorPendingMobileCard';
import { fetchFoodDonorsWithPendingVerifications } from '../../actions/foodDonors';
import useActiveSite from '../../hooks/useActiveSite';

const PendingRegistrationsBreadcrumbs = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={RouterLink}
        to={generatePath(routes.mobileDashboard)}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component={RouterLink} to={routes.mobileToDo} label="To-do" />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="Pending Food Donors" />
    </Breadcrumbs>
  </Box>
);

const containerSx = {
  height: '100%',
  width: '100%',
  overflow: 'auto',
  backgroundColor: 'background.default',
};

const FoodDonorPendingRegistrationsList = () => {
  const activeSite = useActiveSite();
  const dispatch = useDispatch();
  const foodDonors = useSelector((state) => state.entities.foodDonors);
  const foodDonorsList = Object.values(foodDonors.byId);

  useEffect(() => {
    dispatch(fetchFoodDonorsWithPendingVerifications([activeSite.id]));
    window.scrollTo({ top: 0 });
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!foodDonors.inflight && foodDonors.allIds.length === 0) {
    return (
      <>
        <PendingRegistrationsBreadcrumbs />

        <Box sx={containerSx}>
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              WebkitTransform: 'translate(-50%, -50%)',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
            }}
          >
            <Typography color="textSecondary" variant="h5">
              You have no pending food donor registrations
            </Typography>
          </Box>
        </Box>
      </>
    );
  }

  return (
    <>
      <PendingRegistrationsBreadcrumbs />

      <List sx={containerSx} subheader={<li />}>
        <li style={{ backgroundColor: 'inherit' }}>
          <ul style={{ marginBottom: 2, backgroundColor: 'inherit', padding: 0 }}>
            {foodDonorsList.map((foodDonorRequest) => (
              <ListItem key={`fd-${foodDonorRequest.id}`} sx={{ display: 'block', padding: 1 }}>
                <FoodDonorPendingMobileCard foodDonor={foodDonorRequest} />
              </ListItem>
            ))}
          </ul>
        </li>
      </List>
    </>
  );
};

export default FoodDonorPendingRegistrationsList;
